import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Tjenester from "@/pages/Tjenester";
import Helseforsikring from "@/pages/Helseforsikring";
import Bedriftsbehandling from "@/pages/Bedriftsbehandling";
import OmOss from "@/pages/OmOss";
import Kontakt from "@/pages/Kontakt";
import Personvern from "@/pages/Personvern";
import VaareTjenester from "@/pages/VaareTjenester";

function ScrollManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <BrowserRouter>
      <ScrollManager />
      <Navigation />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/tjenester" element={<VaareTjenester />} />
          <Route path="/priser" element={<Tjenester />} />
          <Route path="/helseforsikring" element={<Helseforsikring />} />
          <Route path="/bedriftsbehandling" element={<Bedriftsbehandling />} />
          <Route path="/om-oss" element={<OmOss />} />
          <Route path="/kontakt" element={<Kontakt />} />
          <Route path="/personvern" element={<Personvern />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
